export const windowTitleFormatString = "YnYIUb";
export default {windowTitleFormatString};